import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<div class=\"logo\">\n  <FlightIcon @name=\"hashicorp\" @size=\"24\" />\n</div>")